<template>
  <div class="admin-orders">
    <header-title title="Historial de Pedidos"></header-title>

    <div class="page-title">
      <v-container class="pl-0 pr-0">
        <v-row justify="center">
          <v-col v-if="!hasRoleWaiter" cols="12" sm="6" md="4" lg="2">
            <date-picker-range @updateDates="onChangeDate"></date-picker-range>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field
              outlined
              dense
              label="Buscar"
              v-model="search"
              class="select-box mx-3"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select
              @change="onChangeProductType"
              :items="typeDropdown"
              item-text="label"
              item-value="value"
              label="tipo de producto"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select
              @change="onChangeProductStatus"
              :items="statusDropdown"
              item-text="label"
              item-value="value"
              label="Estado"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select
              v-model="selectedQR"
              :items="activesQR"
              :label="selectLabelQR"
              @change="onChangeTable"
              :item-text="qr => tableQRLabel(qr.table)"
              item-value="table"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-btn
              :style="`border: 3px solid ${colorsGeneralPrimary}`"
              :color="colorsGeneralPrimary"
              outlined
              text
              class="admin-excel-download-btn mx-3"
              @click="$refs.orderHistoryRef.exportToExcel(excelName)"
            >
              Exportar a Excel
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <OrdersHistory
      ref="orderHistoryRef"
      @changeTableFromOrdersHistory="onChangeDate(rangeOfDates)"
      :orders="orders"
      :actives-q-r="activesQR"
      :search="search"
    ></OrdersHistory>
  </div>
</template>

<script>
import moment from "moment";
import OrdersHistory from "../../../components/admin/order/OrdersHistory";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import DatePickerRange from "@/components/common/DatePickerRange";
import { qrCollection } from "@/collections/qrs";

const INITIAL_DATE_START = moment()
  .startOf("day")
  .toDate();
const INITIAL_DATE_END = moment()
  .endOf("day")
  .toDate();

export default {
  name: "OrderHistory",
  components: {
    OrdersHistory,
    HeaderTitle,
    DatePickerRange
  },
  data() {
    return {
      search: "",
      typeDropdown: [
        {
          label: "Todos",
          value: "all"
        },
        {
          label: "Bebidas",
          value: process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID
        },
        {
          label: "Comidas",
          value: process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID
        },
        {
          label: "Postre",
          value: process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID
        }
      ],
      statusDropdown: [
        {
          label: "Todos",
          value: "all"
        },
        {
          label: "Pendientes",
          value: true
        },
        {
          label: "Hechos",
          value: false
        }
      ],
      locale: {
        id: "es",
        firstDayOfWeek: 2,
        masks: {
          input: "YYYY-MM-DD 00:00:00"
        }
      },
      popover: {
        visibility: "click"
      },
      rangeOfDates: {
        start: INITIAL_DATE_START,
        end: INITIAL_DATE_END
      },
      productTypeSelected: "all",
      productStatusSelected: "all",
      selectedQR: { id: "todas", table: "todas" },
      selectLabelQR: "Selecciona mesa",
      qrCollection: []
    };
  },
  firestore() {
    return {
      qrCollection: qrCollection.where("active", "==", true).orderBy("table")
    };
  },
  computed: {
    activesQR() {
      let qr = [...this.qrCollection];
      qr = qr.sort((a, b) => {
        return a.table.localeCompare(b.table, undefined, {
          numeric: true,
          sensitivity: "base"
        });
      });
      return [{ id: "todas", table: "todas" }, ...qr];
    },
    orders() {
      let ordersHistory = [...this.$store.state.orderHistory];

      if (this.productTypeSelected !== "all") {
        ordersHistory = ordersHistory.filter(
          item => item.product_type_id === this.productTypeSelected
        );
      }

      if (this.productStatusSelected !== "all") {
        ordersHistory = ordersHistory.filter(
          item => item.isPending === this.productStatusSelected
        );
      }

      if (
        this.selectedQR !== "todas" &&
        this.selectedQR &&
        this.selectedQR.table !== "todas"
      ) {
        ordersHistory = ordersHistory.filter(
          item => item.tableQR === this.selectedQR
        );
      }

      return ordersHistory;
    },
    excelName() {
      return `historial_pedidos(${this.dayFormat2(
        this.rangeOfDates.start
      )}-${this.dayFormat2(this.rangeOfDates.start)}).xls`;
    },
    total() {
      let total = 0;
      this.orders.forEach(order => {
        total += order.price * order.quantity;
      });

      return total;
    },

    hasRoleWaiter() {
      return this.$store.getters.hasRoleWaiter;
    }
  },
  methods: {
    onChangeDate(dates) {
      let date1;
      let date2;

      if (dates.length === 1 || dates[0] === dates[1]) {
        date1 = moment(dates[0])
          .startOf("day")
          .toDate();
        date2 = moment(dates[0])
          .endOf("day")
          .toDate();
      }

      if (dates.length === 2) {
        date1 = moment(dates[0])
          .startOf("day")
          .toDate();
        date2 = moment(dates[1])
          .endOf("day")
          .toDate();
      }

      let _rangeOfDates = {
        start: date1,
        end: date2
      };

      this.rangeOfDates = _rangeOfDates;

      this.$store.dispatch("ordersHistoryByRangeOfDate", _rangeOfDates);
    },
    onChangeProductType(value) {
      this.productTypeSelected = value;
    },
    onChangeProductStatus(value) {
      this.productStatusSelected = value;
    },
    onChangeTable(value) {
      this.selectedQR = value;
    },
    getType(order) {
      return order.product_type_id === this.$store.state.productTypeIds.drinks
        ? "Bebida"
        : "Comida";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.select-product-type {
  font-size: 16px;
  padding: 6px;
  border-radius: 3px;
  background: #fff;
  margin-left: 10px;
  border: 1px solid #cbd5e0;
}

.filters {
  width: 70%;
  margin: 0 auto;
}

@media (max-width: 991px) {
  .filters {
    width: 100%;
  }
}

::v-deep {
  .vc-popover-content-wrapper {
    @media screen and (max-width: 471px) {
      width: 80%;
      overflow: hidden;
    }
  }

  .vc-popover-content {
    @media screen and (max-width: 471px) {
      width: 95%;
      overflow: auto;
    }
  }
}
</style>
